export interface Country { code: string; name: string }

const RAW: Array<[string, string]> = [
  // EU / EEA
  ['AT', 'Austria'], ['BE', 'Belgium'], ['BG', 'Bulgaria'], ['HR', 'Croatia'], ['CY', 'Cyprus'],
  ['CZ', 'Czechia'], ['DK', 'Denmark'], ['EE', 'Estonia'], ['FI', 'Finland'], ['FR', 'France'],
  ['DE', 'Germany'], ['GR', 'Greece'], ['HU', 'Hungary'], ['IE', 'Ireland'], ['IT', 'Italy'],
  ['LV', 'Latvia'], ['LT', 'Lithuania'], ['LU', 'Luxembourg'], ['MT', 'Malta'], ['NL', 'Netherlands'],
  ['PL', 'Poland'], ['PT', 'Portugal'], ['RO', 'Romania'], ['SK', 'Slovakia'], ['SI', 'Slovenia'],
  ['ES', 'Spain'], ['SE', 'Sweden'], ['IS', 'Iceland'], ['LI', 'Liechtenstein'], ['NO', 'Norway'],
  ['CH', 'Switzerland'], ['GB', 'United Kingdom'],
  // Other Europe
  ['AL', 'Albania'], ['AD', 'Andorra'], ['AM', 'Armenia'], ['AZ', 'Azerbaijan'], ['BY', 'Belarus'],
  ['BA', 'Bosnia and Herzegovina'], ['GE', 'Georgia'], ['MD', 'Moldova'], ['MC', 'Monaco'],
  ['ME', 'Montenegro'], ['MK', 'North Macedonia'], ['RS', 'Serbia'], ['SM', 'San Marino'],
  ['TR', 'Türkiye'], ['UA', 'Ukraine'], ['VA', 'Vatican City'],
  // Rest
  ['AU', 'Australia'], ['BR', 'Brazil'], ['CA', 'Canada'], ['CN', 'China'], ['IN', 'India'],
  ['IL', 'Israel'], ['JP', 'Japan'], ['KR', 'South Korea'], ['MX', 'Mexico'], ['NZ', 'New Zealand'],
  ['SG', 'Singapore'], ['ZA', 'South Africa'], ['AE', 'United Arab Emirates'], ['US', 'United States'],
];

export const COUNTRIES: readonly Country[] = RAW
  .map(([code, name]) => ({ code, name }))
  .sort((a, b) => a.name.localeCompare(b.name, 'en'));
